import React from 'react';
/**
 * @TODO: Add proper Typescript typings.
 * @type {React.Context<{}>}
 */
export const FormFieldContext = React.createContext({});
